import styled from 'styled-components';

const ToastWrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0);
  top: 24px;
  z-index: 50000;

  .toast {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    background: #ffffff;
    box-shadow: 2px 8px 30px rgba(5, 49, 73, 0.1);
    border-radius: 8px;
    min-height: 56px;
    min-width: 340px;
    max-width: 420px;
    user-select: none;
    margin-bottom: 8px;

    .toast-left {
      display: flex;
      flex-direction: row;
      align-items: center;
      flex: 1;
      min-width: 0;

      .toast-color {
        width: 6px;
        align-self: stretch;
        background: #32e5c5;
        border-top-left-radius: 8px;
        border-bottom-left-radius: 8px;
        flex-shrink: 0;
      }

      .toast-icon {
        margin-left: 12px;
        display: flex;
        align-items: center;
        flex-shrink: 0;
      }

      .toast-cotent {
        display: flex;
        flex-direction: column;
        margin-left: 12px;
        margin-right: 8px;
        padding: 12px 0;
        min-width: 0;

        .medium-text {
          font-size: 14px;
          font-weight: 600;
          white-space: nowrap;
        }

        .regular-text {
          font-size: 12px;
          margin-top: 2px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          max-width: 260px;
        }
      }
    }

    .close-btn {
      margin-right: 14px;
      margin-left: 12px;
      cursor: pointer;
      display: flex;
      align-items: center;
      flex-shrink: 0;
      opacity: 0.6;
      &:hover { opacity: 1; }
    }
  }

  .fade-enter {
    opacity: 0.01;
  }

  .fade-enter-active {
    opacity: 1;
    transition: opacity 200ms ease-in;
  }

  .fade-exit {
    opacity: 1;
  }

  .fade-exit-active {
    opacity: 0.01;
    transition: opacity 200ms ease-in;
  }
`;
export default ToastWrapper;
